import React from "react";
import { Box } from "@mui/material";
import { columnsUncertainty } from "./utils/uncertainty.columns";
import FilterUncertainty from "./components/filterUncertainty";
import { useNavigate } from "react-router-dom";
import { GridRowParams } from "@mui/x-data-grid";
import pathRoutes from "../../routes/pathRoutes";
import { useCalibrationUncertainty } from "@services/servicesGenericsTables";
import { CreatePageList } from "@app/components/Layouts/PageList";
import { Add } from "@app/components/Actions";
import { CustomDataGrid } from "@app/components";
import { PermissionComponentGate } from "@app/utils/PermissionComponentGate";
import { RolesTypes } from "../users/utils/helpers";
import usePermission from "@app/context/PermissionContext";

const Uncertainty = () => {
  const { filteredUncertainty } = useCalibrationUncertainty();
  const calibrationUncertaintyList = filteredUncertainty();
  const navigate = useNavigate();
  const { isAdmin, isSuperAdmin } = usePermission();

  const handleRowDoubleClick = (params: GridRowParams): void => {
    if (isAdmin || isSuperAdmin)
      navigate(`${pathRoutes.ADMIN_INCERTIDUMBRES}/editar/${params.id}`);
    else navigate(`${pathRoutes.ADMIN_INCERTIDUMBRES}/ver/${params.id}`);
  };
  return (
    <CreatePageList
      title="Listado de incertidumbres"
      buttonRight={
        <PermissionComponentGate
          permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}
        >
          <Add to={`admin/incertidumbres/nuevo`} title="Nueva incertidumbre" />
        </PermissionComponentGate>
      }
    >
      <FilterUncertainty />
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", mt: 1 }}>
        <CustomDataGrid
          rows={calibrationUncertaintyList}
          columns={columnsUncertainty}
          handleRowDoubleClick={handleRowDoubleClick}
          search={false}
        />
      </Box>
    </CreatePageList>
  );
};

export default Uncertainty;
